module.exports = __webpack_public_path__ + "img/round_and_small.69bc064a.svg";